export const EMBED_TYPES = {
  IFRAME:   'iframe',
  VIDEO_JS: 'videojs',
  IMAGE:    'image'
}

